'use client';

import Composer from '@/common/Composer';
import { HOME_STARTER_QUESTIONS } from '~/constants/home';
import { useShowComposerTreatment } from '~/context/composer/ComposerContext';
import HomeStarterQuestion from './HomeStarterQuestion';

export default function HomeComposerUi() {
  const showComposerTreatment = useShowComposerTreatment();

  if (!showComposerTreatment) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-40">
      <Composer
        inputPlaceholder="Search or ask me anything"
        slot={<HomeStarterQuestion questions={HOME_STARTER_QUESTIONS} />}
      />
    </div>
  );
}
